import { GetSysAuths } from '@/apis/userGroup'
import { routesMap, supplementUpperPage } from '@/router/createRoutes'

import SelectableTable from '@/components/SelectableTable'
import webAuthList from '@/config/pagesAuth.config.json'

export default {
  name: 'AuthsModal',
  components: { SelectableTable },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultChecked: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      confirmLoading: false,
      webAuths: webAuthList,
      // ------------------------------- 页面权限列表 -------------------------------
      webAuthsColumns: [
        {
          title: '页面名称', dataIndex: 'name', key: 'name', width: '50%',
          scopedSlots: { customRender: 'customName' }
        },
        { title: '页面路径', dataIndex: 'path', key: 'path', width: '50%' }
      ],
      webAuthsData: [], // 树形列表的 dataSource
      selectedWebAuthIds: [], // 树形列表选中 keys

      webIdToApiAuths: {}, // 由 webAuthId 索引到该页面拥有的 apiAuths 的对象
      webAuthIds: [] // 要提交的真实页面的 ids
    }
  },
  created() {
    this.getAuthsList()
  },
  computed: {},
  watch: {
    defaultChecked: function(data) {
      if (this.visible) {
        this.setCheckedAuthItems(data)
      }
    }
  },
  methods: {
    // 获取全部权限列表
    async getAuthsList() {
      try {
        let webAuths = this.webAuths

        const keys = Object.keys(webAuths)
        let webAuthsData = []
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          const item = webAuths[key]
          const {description : name} = item
          const path = undefined, apiAuthIds = undefined
          const trData = { key, name, path, apiAuthIds }
          webAuthsData.push(trData)
        }
       this.webAuthsData = webAuthsData
      } catch (error) {}
    },
    // 打开列表时设置勾选项
    setCheckedAuthItems(data) {
      this.selectedWebAuthIds = data
    },
    // 补充 webAuths（授权页面）的上级路径
    supplementUpperPageAuth(webAuths) {
      const pagesName = webAuths.map(auth => auth.id)
      const newPagesName = supplementUpperPage(pagesName)
      const newWebAuths = newPagesName.map(name => {
        let auth = webAuths.find(auth => auth.id === name)
        if (!auth) auth = { id: name }
        return auth
      })
      return newWebAuths
    },
    // 分级：按 . 的个数分级存放（无 . 则是根栏目，一个则是次级栏目...）
    classifyWebAuths(webAuths, level = 0) {
      let classifyWebAuthsArr = []
      const classifyWebAuths = []

      let index = webAuths.length
      while (index--) {
        const auth = webAuths[index]
        const dots = auth.id.match(/\./g) || []
        if (dots.length === level) {
          classifyWebAuths.push(auth)
          webAuths.splice(index, 1)
        }
      }

      classifyWebAuthsArr.push(classifyWebAuths)

      if (webAuths.length) {
        classifyWebAuthsArr = [...classifyWebAuthsArr, ...this.classifyWebAuths(webAuths, ++level)]
      }

      return classifyWebAuthsArr
    },
    // 创建页面授权树形列表的数据
    createWebAuthsTreeData(webAuthsArr, level = 0, key) {
      const upper = []
      const reg = key ? RegExp(`^${key}`) : RegExp('')

      webAuthsArr[level].forEach(auth => {
        // 检查 auth.id 是否以 key 值开头
        if (reg.test(auth.id)) {
          const { id: key, apiAuthIds } = auth
          // 通过 routesMap 获取授权页面的名称和路由的 path
          const { name, path } = routesMap[auth.id]
          const item = { key, name, path, apiAuthIds }

          if (webAuthsArr[level + 1]) {
            const children = this.createWebAuthsTreeData(webAuthsArr, level + 1, auth.id)
            children.length && (item.children = children)
          }

          upper.push(item)
        }
      })
      return upper
    },
    // 树形列表勾选操作后
    handlerSelectedChange(selectedKeys) {
      this.selectedWebAuthIds = selectedKeys
      this.setChildrenSelectedCount(selectedKeys, this.webAuthsData)
    },
    // 将 this.webAuthsData（即树形列表的 dataSource）中
    // 子级选中的个数反映在父级中
    setChildrenSelectedCount(selectedKeys, dataSource) {
      dataSource.forEach(auth => {
        if (auth.children && auth.children.length) {
          auth.selected = 0
          const childrenKeys = auth.children.map(c => c.key)
          childrenKeys.forEach(key => {
            if (selectedKeys.indexOf(key) !== -1) ++auth.selected
          })

          this.setChildrenSelectedCount(selectedKeys, auth.children)
        }
      })
    },
    // ------------------------------- 提交权限 -------------------------------
    handlerSubmit() {
      // 触发提交
      this.$emit('submit', this.selectedWebAuthIds)
      this.confirmLoading = true
    },
    afterHideModal() {
      this.confirmLoading = false
    }
  }
}
